import React from "react";
import { UserStatusT } from "../../constants/user";
import Tag from "@carrier-io/air-react/Tag";
import { getStatusStyles } from "../../utils/getStatusStyles";

export const StatusTag = ({ status }: { status: UserStatusT }) => {
  const statusStyles = getStatusStyles(status);

  return <Tag color={statusStyles?.color} label={status} size="xsmall" />;
};
